<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>

    <div class="list-content-div">
      <div class="list-header-row">
        <div class="list-header-title-div">空开商品订单</div>
        <div class="page-action-btns flex">
          <button class="common-bg-button" @click="toggleFilters">高级筛选</button>
          <button class="common-bg-button" @click="handleExport">导 出</button>
        </div>
      </div>

      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input clearable v-model="queryInfo.keyWord" size="small"
                placeholder="请输入商品订单编号/用户手机号/支付宝交易流水"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">商品订单状态</p>
              <el-select v-model="queryInfo.orderStatus" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="终止信用授权中" value="IN_CANCEL_LOAD" />
                <el-option label="已终止信用授权" value="CLOSED" />
                <el-option label="已信用授权" value="IN_AUTHORIZE" />
                <el-option label="信用履约中" value="IN_USE" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">信用授权终止类型</p>
              <el-select v-model="queryInfo.refundReason" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="用户申请" value="用户申请" />
                <el-option label="系统自动" value="系统自动" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <p class="margin-bottom-5 font-14">信用授权终止审核状态</p>
              <el-select v-model="queryInfo.refundStatus" size="small" clearable placeholder="请选择" style="width: 100%">
                <el-option label="待审核" value="LOAD_AUDI" />
                <el-option label="全额退款" value="ALL" />
                <el-option label="拒绝退款" value="REJECT" />
                <el-option label="无需审核" value="NOT_AUDI" />
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="12">
              <p class="margin-bottom-5 font-14">商品订单创建时间</p>
              <el-date-picker v-model="queryInfo.orderCreateTimeRange" type="daterange" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 100%"
                value-format="yyyy-MM-dd" />
            </el-col>
            <el-col :span="12">
              <p class="margin-bottom-5 font-14">用户申请时间</p>
              <el-date-picker v-model="queryInfo.userApplicationTimeRange" type="datetimerange" range-separator="-"
                start-placeholder="开始日期时间" end-placeholder="结束日期时间" size="small" style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss" @change="handleUserApplicationTimeChange" />
            </el-col>
          </el-row>
        </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button class="common-bg-button" @click="reset">重 置</button>
          <button class="common-bg-button" @click="search">搜 索</button>
        </div>
      </div>

      <el-table :data="orderList" size="small" border style="width: 100%">
        <el-table-column prop="purchaseTime" label="商品订单创建时间" min-width="170" align="center">
          <template slot-scope="scope">
            {{ scope.row.purchaseTime || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="mapNo" label="商品订单编号" min-width="220" align="center" />
        <el-table-column prop="activityOrderNo" label="关联活动订单编号" min-width="220" align="center" />
        <el-table-column prop="mobile" label="用户手机号" min-width="140" align="center" />
        <el-table-column prop="orderName" label="购买商品名称" min-width="180" align="center" />
        <el-table-column prop="orderDetail" label="购买商品内容" min-width="200" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderDetail || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="activityAmountPrice" label="免押金额 (元)" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="actualAmount" label="实收金额 (元)" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="deductionWay" label="支付方式" min-width="120" align="center">
          <template slot-scope="scope">
            <span>支付宝</span>
          </template>
        </el-table-column>
        <el-table-column prop="transactionNo" label="支付宝交易流水号" min-width="240" align="center" />
        <el-table-column prop="orderStatusName" label="商品订单状态" min-width="140" align="center">
        </el-table-column>

        <el-table-column prop="activityOrderStatusName" label="关联活动订单状态" min-width="140" align="center">
        </el-table-column>

        <el-table-column prop="refundReason" label="信用授权终止类型" min-width="140" align="center">
        </el-table-column>

        <el-table-column prop="refundFromTime" label="用户申请时间" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="refundStatus" label="信用授权终止审核状态" min-width="150" align="center">
        </el-table-column>
        <el-table-column prop="cancelFinishTime" label="信用终止时间" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="activityOrderOriginPrice" label="免押扣款金额（元）" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="refundReasonRemark" label="审核拒绝原因" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="refundByName" label="信用终止审核人" min-width="140" align="center">
        </el-table-column>
        <el-table-column prop="refundOperationTime" label="信用终止审核操作时间" min-width="150" align="center">
        </el-table-column>
        <el-table-column label="信用授权终止审核操作" min-width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <div v-if="scope.row.refundStatus === '待审核'" class="audit-buttons">
              <button class="audit-btn approve-btn" @click="handleApprove(scope.row)">
                <span>通过</span>
              </button>
              <span class="divider"></span>
              <button class="audit-btn reject-btn" @click="handleReject(scope.row)">
                <span>拒绝</span>
              </button>
            </div>
            <span v-else-if="scope.row.refundStatus === '无需审核'" class="status-badge status-no-audit">无需审核</span>
            <span v-else-if="scope.row.refundStatus === '全额退款'" class="status-badge status-refunded">已退款</span>
            <span v-else-if="scope.row.refundStatus === '拒绝退款'" class="status-badge status-rejected">已拒绝</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="list-pagination" style="margin-top: 16px;">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>

    <!-- 审核通过确认弹窗 -->
    <el-dialog title="确认通过审核" :visible.sync="approveDialogVisible" width="500px" :close-on-click-modal="false"
      @close="closeApproveDialog">
      <div class="dialog-content">
        <p class="confirm-text">确认通过该订单的信用授权终止审核？</p>
        <div class="order-info">
          <div class="info-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ currentOrder?.mapNo || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">用户手机号：</span>
            <span class="value">{{ currentOrder?.mobile || '--' }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="common-empty-button" @click="closeApproveDialog">取 消</button>
        <button class="common-bg-button" @click="confirmApprove" :disabled="auditLoading">确 定</button>
      </span>
    </el-dialog>

    <!-- 审核拒绝弹窗 -->
    <el-dialog title="确认拒绝审核" :visible.sync="rejectDialogVisible" width="600px" :close-on-click-modal="false"
      @close="closeRejectDialog">
      <div class="dialog-content">
        <p class="confirm-text">确认拒绝该订单的信用授权终止审核？</p>
        <div class="order-info">
          <div class="info-item">
            <span class="label">订单编号：</span>
            <span class="value">{{ currentOrder?.mapNo || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">用户手机号：</span>
            <span class="value">{{ currentOrder?.mobile || '--' }}</span>
          </div>
        </div>
        <el-form :model="rejectForm" :rules="rejectRules" ref="rejectFormRef" label-position="top" class="reject-form">
          <el-form-item label="拒绝原因" prop="refundRemark">
            <el-input type="textarea" v-model="rejectForm.refundRemark" size="small" placeholder="请详细说明拒绝原因"
              :maxlength="200" show-word-limit rows="4" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="common-empty-button" @click="closeRejectDialog">取 消</button>
        <button class="common-bg-button" @click="confirmReject" :disabled="auditLoading">确 定</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMultiQuerys: false,
      // 审核弹窗相关
      approveDialogVisible: false,
      rejectDialogVisible: false,
      currentOrder: null,
      auditLoading: false,
      rejectForm: {
        refundRemark: ''
      },
      rejectRules: {
        refundRemark: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      },
      queryInfo: {
        keyWord: "",
        productOrderStatus: "",
        creditAuthTerminateType: "",
        creditTerminateAuditStatus: "",
        pageNum: 1,
        pageSize: 10,
      },
      orderList: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      breadCrumb: [
        {
          name: "营销活动",
        },
        {
          name: "空开活动",
        },
        {
          name: "空开商品订单",
        },
      ],
    };
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    // 清理查询参数，移除空值
    cleanQueryInfo(queryInfo) {
      const clean = {};
      Object.keys(queryInfo).forEach(key => {
        // 排除前端用的日期范围字段
        if (key === 'userApplicationTimeRange' || key === 'orderCreateTimeRange') {
          return;
        }
        const value = queryInfo[key];
        if (value !== null && value !== undefined && value !== '') {
          clean[key] = value;
        }
      });
      return clean;
    },
    // 获取列表数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);

      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 1;
      } else {
        _.pagination.current = pagination.current;
        _.queryInfo.pageNum = pagination.current;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.activityType = 'CIRCUIT_BREAKER_ACTIVITY'; // 固定参数：空开活动

      // 处理日期范围
      if (_.queryInfo.orderCreateTimeRange && _.queryInfo.orderCreateTimeRange.length === 2) {
        _.queryInfo.createFromTime = _.queryInfo.orderCreateTimeRange[0];
        _.queryInfo.createToTime = _.queryInfo.orderCreateTimeRange[1];
      } else {
        _.queryInfo.createFromTime = '';
        _.queryInfo.createToTime = '';
      }

      if (_.queryInfo.userApplicationTimeRange && _.queryInfo.userApplicationTimeRange.length === 2) {
        const [start, end] = _.queryInfo.userApplicationTimeRange;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          _.queryInfo.refundFromStartTime = startDate + ' 00:00:00';
          _.queryInfo.refundFromEndTime = endDate + ' 23:59:59';
        } else {
          _.queryInfo.refundFromStartTime = start;
          _.queryInfo.refundFromEndTime = end;
        }
      } else {
        _.queryInfo.refundFromStartTime = '';
        _.queryInfo.refundFromEndTime = '';
      }

      const cleanQueryInfo = _.cleanQueryInfo(_.queryInfo);
      _.$H.post(_, _.$A.activityOrder.circuitBreakerActivityCommodityOrderList, cleanQueryInfo).then(res => {
        const payload = res?.data?.data ?? res?.data ?? {};
        _.orderList = payload.content || [];
        _.pagination.total = payload.totalElements ?? payload.total ?? 0;
        _.$U.hideLoading(_);
      }).catch(err => {
        _.orderList = [];
        _.pagination.total = 0;
        _.$U.hideLoading(_);
      });
    },
    toggleFilters() {
      this.showMultiQuerys = !this.showMultiQuerys;
    },
    reset() {
      this.queryInfo = {
        keyWord: "",
        productOrderStatus: "",
        creditAuthTerminateType: "",
        creditTerminateAuditStatus: "",
        orderCreateTimeRange: [],
        userApplicationTimeRange: [],
        pageNum: 1,
        pageSize: 10,
      };
      this.getListData(this.pagination, true);
    },
    search() {
      this.getListData(this.pagination, true);
    },
    // 用户申请时间变化时，同一天自动填充00:00:00和23:59:59
    handleUserApplicationTimeChange(val) {
      if (val && val.length === 2) {
        const [start, end] = val;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          this.queryInfo.userApplicationTimeRange = [
            startDate + ' 00:00:00',
            endDate + ' 23:59:59'
          ];
        }
      }
    },
    handleExport() {
      let _ = this;
      _.$U.showLoading(_);

      // 处理日期范围
      if (_.queryInfo.orderCreateTimeRange && _.queryInfo.orderCreateTimeRange.length === 2) {
        _.queryInfo.createFromTime = _.queryInfo.orderCreateTimeRange[0];
        _.queryInfo.createToTime = _.queryInfo.orderCreateTimeRange[1];
      } else {
        _.queryInfo.createFromTime = '';
        _.queryInfo.createToTime = '';
      }

      if (_.queryInfo.userApplicationTimeRange && _.queryInfo.userApplicationTimeRange.length === 2) {
        const [start, end] = _.queryInfo.userApplicationTimeRange;
        const startDate = start ? String(start).slice(0, 10) : '';
        const endDate = end ? String(end).slice(0, 10) : '';
        if (startDate && endDate && startDate === endDate) {
          _.queryInfo.refundFromStartTime = startDate + ' 00:00:00';
          _.queryInfo.refundFromEndTime = endDate + ' 23:59:59';
        } else {
          _.queryInfo.refundFromStartTime = start;
          _.queryInfo.refundFromEndTime = end;
        }
      } else {
        _.queryInfo.refundFromStartTime = '';
        _.queryInfo.refundFromEndTime = '';
      }

      const exportQueryInfo = _.cleanQueryInfo(_.queryInfo);
      exportQueryInfo.corpNo = _.$store.state.corpNo;

      _.$H.post(_, '/api/d1/activityOrderActivityMap/circuitBreakerActivity/activityExport', exportQueryInfo).then((res) => {
        _.$U.hideLoading(_);

        if (res.data && res.data.data) {
          const responseData = res.data.data;

          // 处理 base64 或 fileName 方式的导出
          if (responseData.base64 || responseData.fileName) {
            _.$U.saveExcelFile(responseData);
            _.$U.success('导出成功');
          }
          // 处理 filePath 方式的导出
          else if (responseData.filePath) {
            // 直接使用 API 代理路径下载，避免跨域和路径问题
            const downloadUrl = `/api/d1${responseData.filePath}`;

            // 创建隐藏的 a 标签进行下载
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = responseData.filePath.split('/').pop() || 'export.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            _.$U.success('导出成功');
          } else {
            _.$U.error('导出失败：未获取到文件信息');
          }
        } else {
          _.$U.error(res.data?.msg || res.data?.message || '导出失败：未获取到文件信息');
        }
      }).catch((err) => {
        _.$U.hideLoading(_);
        _.$U.error(err?.response?.data?.msg || err?.response?.data?.message || err?.message || '导出失败');
      });
    },
    // 审核通过
    handleApprove(row) {
      this.currentOrder = row;
      this.approveDialogVisible = true;
    },
    confirmApprove() {
      this.auditLoading = true;
      const params = {
        cancelNo: this.currentOrder.cancelNo || '',
        refundAmount: this.currentOrder.actualAmount || 0,
        activityOrderNo: this.currentOrder.activityOrderNo || '',
        refundReason: '系统自动',
        refundType: 'ALL',
        corpNo: this.$store.state.corpNo,
        activityExtendTypeEnum: 'CIRCUIT_BREAKER_ACTIVITY'
      };

      this.$H.post(this, '/api/d1/activityOrderCancelRequestRecord/circuitBreakerActivity/orderRefund', params).then(() => {
        this.$message.success('审核通过');
        this.auditLoading = false;
        this.approveDialogVisible = false;
        this.currentOrder = null;
        this.getListData(this.pagination, false);
      }).catch(() => {
        this.auditLoading = false;
        this.$message.error('审核失败');
      });
    },
    closeApproveDialog() {
      this.approveDialogVisible = false;
      this.currentOrder = null;
    },
    // 审核拒绝
    handleReject(row) {
      this.currentOrder = row;
      this.rejectForm = {
        refundRemark: ''
      };
      this.rejectDialogVisible = true;
    },
    confirmReject() {
      this.$refs.rejectFormRef.validate((valid) => {
        if (valid) {
          this.auditLoading = true;
          const params = {
            cancelNo: this.currentOrder.cancelNo || '',
            refundAmount: this.currentOrder.actualAmount || 0,
            activityOrderNo: this.currentOrder.activityOrderNo || '',
            refundReason: '系统自动',
            refundType: 'REJECT',
            refundRemark: this.rejectForm.refundRemark,
            corpNo: this.$store.state.corpNo,
            activityExtendTypeEnum: 'CIRCUIT_BREAKER_ACTIVITY'
          };

          this.$H.post(this, '/api/d1/activityOrderCancelRequestRecord/circuitBreakerActivity/orderRefund', params).then(() => {
            this.$message.success('审核已拒绝');
            this.auditLoading = false;
            this.rejectDialogVisible = false;
            this.currentOrder = null;
            this.rejectForm = {
              refundRemark: ''
            };
            this.getListData(this.pagination, false);
          }).catch(() => {
            this.auditLoading = false;
            this.$message.error('审核失败');
          });
        }
      });
    },
    closeRejectDialog() {
      this.rejectDialogVisible = false;
      this.currentOrder = null;
      this.rejectForm = {
        refundRemark: ''
      };
      if (this.$refs.rejectFormRef) {
        this.$refs.rejectFormRef.resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-action-btns {
  gap: 12px;
}

.margin-tb-10 {
  margin: 10px 0;
}

.multi-query-div {
  padding: 16px;
  background: #f6f8fb;
  border-radius: 6px;
}

.flex-grow-1 {
  flex-grow: 1;
}

.audit-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  .divider {
    width: 1px;
    height: 16px;
    background-color: #d9d9d9;
    margin: 0 4px;
  }

  .audit-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid;
    outline: none;
    line-height: 1.4;

    i {
      font-size: 12px;
    }

    &:hover {
      opacity: 0.85;
    }

    &:active {
      opacity: 1;
    }
  }

  .approve-btn {
    background: #1677ff;
    border-color: #1677ff;
    color: #ffffff;

    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }

    &:active {
      background: #0958d9;
      border-color: #0958d9;
    }
  }

  .reject-btn {
    background: #ffffff;
    border-color: #ff4d4f;
    color: #ff4d4f;

    &:hover {
      background: #fff1f0;
      border-color: #ff7875;
      color: #ff7875;
    }

    &:active {
      background: #ffe7e7;
      border-color: #d9363e;
      color: #d9363e;
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  border: 1px solid;
  line-height: 1.4;
}

.status-no-audit {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #666666;
}

.status-refunded {
  background: #f6ffed;
  border-color: #b7eb8f;
  color: #52c41a;
}

.status-rejected {
  background: #fff1f0;
  border-color: #ffccc7;
  color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  .common-bg-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.dialog-content {
  padding: 8px 0;

  .confirm-text {
    font-size: 14px;
    color: #333333;
    margin-bottom: 20px;
    line-height: 1.8;
  }

  .order-info {
    background-color: #f6f8fa;
    border: 1px solid #d0d7de;
    border-radius: 4px;
    padding: 16px 20px;
    margin-bottom: 20px;

    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        color: #666666;
        min-width: 100px;
      }

      .value {
        color: #333333;
        flex: 1;
      }
    }
  }

  .reject-form {
    margin-top: 0;

    ::v-deep .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        font-size: 14px;
        color: #666666;
        font-weight: 400;
        padding: 0 0 8px 0;
        line-height: 1.5;
      }

      .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    ::v-deep .el-textarea {
      .el-textarea__inner {
        border: 1px solid #d0d7de;
        border-radius: 4px;
        font-size: 14px;
        color: #333333;
        padding: 8px 12px;
        line-height: 1.6;

        &:focus {
          border-color: #4182eb;
        }

        &::placeholder {
          color: #999999;
        }
      }
    }
  }
}
</style>
